import { loadStripe } from '@stripe/stripe-js';

// Stripe configuration
export const STRIPE_CONFIG = {
  publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51S5MYJ9ilHGKF2nEJCdELLWdV91GOkgeUKE46mAMF0a4bKSssf6JCJiPcHmRdSO6HmnQHoCwUsf6PL3IMBUzwF4o00UXee318u',
  // Note: Secret key should NEVER be in frontend code - this is for reference only
  // It should be used in backend/serverless functions
  secretKey: process.env.STRIPE_SECRET_KEY || 'sk_test_51S5MYJ9ilHGKF2nEF08VDxUyI61Z1RUaoFHeMZpTUA9BsE5jD7vSphqWZQXWXYgkTcZplOIIXaqc4dhfyhe5RXac00h4nLNIdV',
  
  // Price IDs for different plans (created in Stripe Dashboard)
  prices: {
    pro_monthly: process.env.REACT_APP_STRIPE_PRO_MONTHLY_PRICE || 'price_1S5NkN9ilHGKF2nEvWtWo4oK', 
    pro_yearly: process.env.REACT_APP_STRIPE_PRO_YEARLY_PRICE || 'price_1S5Nky9ilHGKF2nEtuqYAlHO',
  },
  
  // Product IDs for reference
  products: {
    pro_monthly: 'prod_T1QbJZwdUKO94u',
    pro_yearly: 'prod_T1QcDUDZFQR6s9',
  },
  
  // URLs for redirect after payment
  urls: {
    success: `${window.location.origin}/payment-success`,
    cancel: `${window.location.origin}/payment-cancel`,
  }
};

// Initialize Stripe
export const stripePromise = loadStripe(STRIPE_CONFIG.publishableKey);

// Subscription plans
export const SUBSCRIPTION_PLANS = {
  free: {
    name: 'Free',
    price: 0,
    interval: null,
    features: [
      'Access all prompt templates',
      'Copy & download prompts',
      'Basic dashboard access',
      'Requires own API keys',
    ],
    limitations: [
      'Cannot save prompts to cloud',
      'Must provide own API keys',
      'Limited to local storage only',
    ]
  },
  pro_monthly: {
    name: 'Pro Monthly',
    price: 9,
    interval: 'month',
    priceId: STRIPE_CONFIG.prices.pro_monthly,
    features: [
      'Save unlimited prompts to cloud',
      'No API keys required',
      'Access to app\'s premium AI models',
      'Full dashboard with analytics',
      'Share prompts with community',
      'Priority support',
      'Early access to new features',
    ],
    popular: true
  },
  pro_yearly: {
    name: 'Pro Yearly',
    price: 99,
    interval: 'year',
    priceId: STRIPE_CONFIG.prices.pro_yearly,
    features: [
      'Everything in Pro Monthly',
      'Save 2 months (17% discount)',
      'Priority email support',
      'Beta features access',
    ],
    savings: '2 months free'
  }
};